/**
 * useChatCapabilities: quali azioni mostrare per il numero WhatsApp attivo.
 * La logica e' in chatCapabilities.ts (pura, testata); qui si leggono solo i dati:
 * service_name dalla configurazione caricata e motore WAHA rilevato dal servizio.
 */

import { useEffect, useState } from 'react';
import { useWhatsAppChatStore } from '@/lib/stores/whatsappChatStore';
import { getWahaService } from '@/lib/services/wahaApiService';
import { getChatCapabilities, isCloudService, type ChatCapabilities } from '@/lib/services/whatsapp/chatCapabilities';

function readWahaState(): { engine: string | null; unsupported: string[] } {
  try {
    const s = getWahaService();
    return { engine: s.getEngine(), unsupported: s.getUnsupportedFeatures() };
  } catch {
    return { engine: null, unsupported: [] };
  }
}

export function useChatCapabilities(): ChatCapabilities {
  const serviceName = useWhatsAppChatStore((s) => s.wahaConfig?.serviceName);
  const session = useWhatsAppChatStore((s) => s.wahaConfig?.session);
  const [engine, setEngine] = useState<string | null>(() => readWahaState().engine);

  useEffect(() => {
    if (isCloudService(serviceName)) return;
    let cancelled = false;
    try {
      getWahaService().detectEngine().then((e) => { if (!cancelled) setEngine(e); });
    } catch {
      // servizio non ancora inizializzato: resta motore ignoto (si prova, 501 spegne)
    }
    return () => { cancelled = true; };
  }, [serviceName, session]);

  // I 501 arrivati durante la sessione si rileggono a ogni render (costo trascurabile).
  const { unsupported } = readWahaState();
  return getChatCapabilities({ serviceName, engine, unsupported });
}
